import useAuth from '../../../app/src/features/authentication/hooks/useAuth';

export const DE_MOTO_VERZEKERING = 'de_motoverzekering';

const useIsDeMotoVerzekeringEnabled = (): boolean => {
  const { campaign } = useAuth();

  if (!campaign) return false;

  // DeMotoVerzekering is enabled when the only insurance company is DE_MOTO_VERZEKERING
  const isEnabled =
    campaign?.insurances?.[0]?.insurance_company === DE_MOTO_VERZEKERING;
  return isEnabled;
};

export default useIsDeMotoVerzekeringEnabled;
